import React, { FunctionComponent, useState } from 'react'
import { Alert, Button, Input, Space } from 'antd'

const { TextArea } = Input

interface StepProps {
	onBack: () => void
	onAction: (reason: string, files: any[]) => void
}

const Step2: FunctionComponent<StepProps> = (props) => {
	const { onBack, onAction } = props

	const [reason, setReason] = useState('')

	const handleNext = () => onAction(reason, [])

	const reasonPlaceholder = `Please explain your challenges in detail.
If this is a resume or document review, please attach it here or provide a link.`

	return (
		<section className="RequestCallModalStep2">
			<Space direction="vertical">
				<Alert
					type="info"
					showIcon
					message=""
					description="All calls will take place through the getWise platform, please do not include your phone number or personal
							contact information. You will receive a text message and email calendar invite (please check spam) with the
							call login instructions."
				/>

				<h3>Reason for your call</h3>

				<TextArea
					autoSize={{ minRows: 4, maxRows: 8 }}
					placeholder={reasonPlaceholder}
					value={reason}
					onChange={(e) => setReason(e.target.value)}
				/>
			</Space>

			<footer style={{ marginTop: 25 }}>
				<Space>
					<Button type="default" shape="round" size="large" onClick={onBack}>
						Back
					</Button>
					<Button type="primary" shape="round" size="large" onClick={handleNext} disabled={!reason}>
						Next
					</Button>
				</Space>
			</footer>
		</section>
	)
}

export default Step2
